<template>
  <div id="adress">
    <headTop @logout="logoutClick"></headTop>
    <section class="container">
      <div class="title">
        <div>{{modify}}收货地址</div>
        <div @click="goBack">> 返回</div>
      </div>

      <div class="infor">
        <div class="list">
          <div class="f3">收货人</div>
          <div class="f7">
            <input type="text" placeholder="请输入收货人姓名" maxlength="10" v-model="userName" />
          </div>
        </div>
        <div class="list">
          <div class="f3">收货人手机号</div>
          <div class="f7">
            <input type="text" placeholder="请输入收货人手机号" v-model="phone" />
          </div>
        </div>
        <div class="adress">
          <div class="f3">地址信息</div>
          <div class="f7" @click="selectAdress">
            <input type="text" placeholder="请选择" readonly οnfοcus="this.blur()" v-model="adress" />
            <div></div>
          </div>
        </div>
        <div class="detail_adress">
          <div class="detail_name">详细地址</div>
          <div class="textcontent">
            <textarea placeholder="如道路、门牌号、小区、楼栋号、单元 室等" v-model="detailAdress"></textarea>
          </div>
        </div>

        <div class="list">
          <div class="f3">邮编</div>
          <div class="f7">
            <input type="text" placeholder="(非必填)请输入邮编" v-model="code" />
          </div>
        </div>
        <div class="list">
          <div class="f3">设为默认地址</div>
          <div class="f7">
            <mt-switch class="switch" @change="getswitch" v-model="onswitch"></mt-switch>
          </div>
        </div>
        <AdressList v-show="showList" @addressList="getAdress"></AdressList>
      </div>
    </section>
    <div id="bottom-button">
      <div class="wrapper">
        <div
          class="button"
          :class="{'inactive':issubmit,'active':!issubmit}"
          @click="save"
        >{{message}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import headTop from './header'
import AdressList from '../components/adress_list'
import { _throttle } from '../utils/public'

export default {
  name: 'adress',
  components: { headTop, AdressList },
  data () {
    return {
      type: 1, // 1 表示新增地址  0//表示修改地址
      userName: '', // 收货人姓名
      phone: '', // 手机号
      adress: '', // 地址
      detailAdress: '', // 详细地址
      province: '',
      city: '',
      district: '',
      code: '', // 邮编
      showList: false, // 展示地址列表
      onswitch: false,
      disable: true, // 禁止提交
      is_default: 0, // 1为默认地址
      id: '', // 修改地址的id
      user_id: '',
      message: '保存地址',
      modify: '新增'

    }
  },
  created () {
    if (this.$route.query.adress) {
      this.type = this.$route.query.type
      let data = JSON.parse(this.$route.query.adress)

      this.province = data.province
      this.city = data.city
      this.district = data.area
      this.adress = `${data.province} ${data.city} ${data.area}`
      this.phone = data.phone
      this.code = data.zip_code
      this.userName = data.name
      this.detailAdress = data.address
      this.is_default = data.is_default
      if (this.is_default === 1) {
        this.onswitch = true
      } else {
        this.onswitch = false
      }

      this.id = data.id
      this.user_id = data.user_id
      this.message = '确认修改'
      this.modify = '修改'
    }
  },
  computed: {
    issubmit: function () {
      if (this.userName.trim() !== '' && this.phone.trim() !== '' && this.adress !== '' && this.detailAdress !== '') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    selectAdress () { // 选择地址
      this.showList = true
    },
    getAdress (bool, province, city, district) {
      this.showList = bool
      if (province !== '') {
        this.province = province
        this.city = city
        this.district = district
        this.adress = `${province} ${city} ${district}`
      }
    },
    getswitch () {
      if (this.onswitch) {
        this.is_default = 1
      } else {
        this.is_default = 0
      }
    },
    save: _throttle(function () {
      if (this.issubmit === false) {
        if (this.userName.trim() === '') {
          this.$Message.warning({
            content: '请填写收货人',
            duration: 1.5
          })
          return false
        }
        if (!/^1[3456789]\d{9}$/.test(this.phone.trim())) {
          this.$Message.warning({
            content: '请检查手机号是否正确',
            duration: 1.5
          })
          return false
        }
        if (this.adress === '') {
          this.$Message.warning({
            content: '请选择所在地信息',
            duration: 1.5
          })
          return false
        }
        if (this.detailAdress === '') {
          this.$Message.warning({
            content: '请填写详细地址',
            duration: 1.5
          })
          return false
        }

        if (this.type === 1) { // 新增地址
          let obj = {
            phone: this.phone,
            name: this.userName,
            zip_code: this.code,
            province: this.province,
            city: this.city,
            area: this.district,
            address: this.detailAdress,
            is_default: this.is_default
          }
          this.utils.POSTHeaderQS(this.accountUrl + '/site/save', {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 0,
            'zxzxkey': ''
          }, true, obj, (response) => {
            if (response.success === true) {
              this.$Message.success(`${response.message}`)
              this.$router.go(-1)
            }
          })
        }

        if (this.type === 0) {
          // 表示修改
          let obj = {
            phone: this.phone,
            name: this.userName,
            zip_code: this.code,
            province: this.province,
            city: this.city,
            area: this.district,
            address: this.detailAdress,
            is_default: this.is_default,
            id: this.id,
            user_id: this.user_id
          }
          this.utils.POSTHeaderQS(this.accountUrl + '/site/update', {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 0,
            'zxzxkey': ''
          }, true, obj, (response) => {
            if (response.success === true) {
              this.$Message.success(`${response.message}`)
              this.$router.go(-1)
            }
          })
        }
      }
    }, 4000),
    goBack () {
      this.$router.go(-1)
    },
    logoutClick () { // 退出登录
      this.$router.replace('home')
    }

  }

}
</script>
<style lang="scss" scoped>
#adress {
  * {
    padding: 0;
    margin: 0;
  }
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '\5FAE\8F6F\96C5\9ED1', Arial, sans-serif;
  .container {
    background: #f4f4f4;
    .title {
      height: 50px;
      width: 100%;
      padding: 0 15px;
      background: #fff;
      div:first-child {
        float: left;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        font-weight: 700;
        color: #000;
      }
      div:last-child {
        float: right;
        height: 50px;
        line-height: 50px;
        font-size: 12px;
        color: #808080;
      }
    }
    .infor {
      width: 100%;
      margin-top: 10px;
      padding: 0 15px;
      background: #fff;
      .list {
        height: 50px;
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        display: -webkit-flex;
        .f3 {
          flex: 3;
          -webkit-flex: 3;
          line-height: 50px;
          font-size: 14px;
          color: #000;
        }
        .f7 {
          flex: 7;
          -webkit-flex: 7;
          height: 30px;
          line-height: 30px;
          margin-top: 10px;
          input {
            height: 30px;
            width: 100%;
            border: none;
            outline: none;
            font-size: 14px;
            color: #000;
            // -webkit-text-fill-color: #000;
            // -webkit-opacity: 1;
            // opacity: 1;
          }
          input:disabled {
            color: #000;
            -webkit-text-fill-color: #000;
            -webkit-opacity: 1;
            opacity: 1;
          }

          input::placeholder {
            font-size: 14px;
            color: #bebebe;
            -webkit-text-fill-color: #bebebe;
          }
          input::-webkit-input-placeholder {
            font-size: 14px;
            color: #bebebe;
            -webkit-text-fill-color: #bebebe;
          }
          input::input-placeholder {
            font-size: 14px;
            color: #bebebe;
            -webkit-text-fill-color: #bebebe;
          }
        }
        .mint-switch {
          width: 52px;
          float: right;
          margin-right: 0;
          .mint-switch-core {
            border-color: #c41335;
            background-color: #c41335;
          }
        }
      }
      .adress {
        height: 50px;
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        display: -webkit-flex;
        .f3 {
          flex: 3;
          -webkit-flex: 3;
          line-height: 50px;
          font-size: 14px;
          color: #000;
        }
        .f7 {
          flex: 7;
          -webkit-flex: 7;
          height: 30px;
          line-height: 30px;
          margin-top: 10px;
          position: relative;
          input {
            height: 30px;
            width: 100%;
            border: none;
            outline: none;
            color: #000;
            font-size: 14px;
            // -webkit-text-fill-color: #000;
            // -webkit-opacity: 1;
            // opacity: 1;
          }
          input::placeholder {
            font-size: 14px;
            color: #bebebe;
          }
          div {
            position: absolute;
            top: -10px;
            right: 5px;
            width: 30px;
            height: 50px;
            background: url('../assets/arrow.png') no-repeat center center;
            background-size: 15px 15px;
            margin: 0;
          }
        }
      }
      .detail_adress {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        border-bottom: 1px solid #f4f4f4;
        .detail_name {
          flex: 3;
          -webkit-flex: 3;
          min-height: 100px;
          font-size: 14px;
          padding-top: 15px;
          margin: 0;
          color: #000;
        }
        .textcontent {
          padding-top: 15px;
          flex: 7;
          min-height: 100px;
          -webkit-flex: 7;
          textarea {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            font-size: 14px;
          }
          textarea::placeholder {
            font-size: 14px;
            color: #bebebe;
          }
        }
      }
    }
  }
  .wrapper {
    position: fixed;
    width: 100%;
    bottom: 0px;
    height: 65px;
    background-color: #ffffff;
    border-top: solid #eeeeee 1px;
    box-sizing: border-box;
    z-index: 100;
  }
  .wrapper .button {
    position: absolute;
    left: 15px;
    right: 15px;
    top: 10px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 15px;
    color: #ffffff;
    border-radius: 3px;
  }
  .inactive {
    background-color: #fe9797;
  }
  .active {
    background-color: #c41335;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/modify-adress.vue